(function() {
  'use strict';

  const selectors = {
    menu_open: '.js__menu__open'
  };

  const classes = {
    body_toggle: 'menu-is-open'
  };

  const init = () => {
    

    // open mobile menu
    document.querySelectorAll(selectors.menu_open).forEach(function(el) {
      console.log('test2');
      el.addEventListener('click', function(e) {
        document.body.classList.toggle(classes.body_toggle);
      });
    });

  };

  window.addEventListener('load', init);
})();
